import React, {useEffect, useState} from 'react';
import {isEmpty} from "@helpers/helpers";
import {getProminentRealtors} from "@models/user";
import usePrevious from "@hooks/previous";
import RealtorsSlider from "./realtors_slider";

function RealtorsProminentsSlider({realtorsLists, city_id, includes_area = false, district_id = [], className}) {
    const [realtors, setRealtors] = useState(realtorsLists ?? []);
    const prevCityId = usePrevious(city_id);
    const prevDistricts = usePrevious(JSON.stringify(district_id));


    useEffect(() => {
        if (!isEmpty(city_id)) {

            if ((isEmpty(realtors) || !realtors.length) && (city_id !== prevCityId || JSON.stringify(district_id) !== prevDistricts)) {
                const sendCity = (isEmpty(district_id) || district_id.length < 1);

                getProminentRealtors(sendCity ? city_id : null, includes_area, district_id).then(result => {
                    setRealtors(result.realtors);

                    const propertiesNoResultTag = document.getElementById('propertiesNoResult');
                    const realtorsProminentsSection = document.querySelector('.realtors-prominents-section');

                    if (!result.realtors.length) {
                        if (!isEmpty(propertiesNoResultTag)) {
                            const selectedRealtorsTag = propertiesNoResultTag.querySelector('.selected-realtors')

                            if (!isEmpty(selectedRealtorsTag)) {
                                selectedRealtorsTag.remove();
                            }
                        }

                        if (!isEmpty(realtorsProminentsSection)) {
                            realtorsProminentsSection.classList.add('d-none')
                        }
                    } else {
                        if (!isEmpty(realtorsProminentsSection)) {
                            realtorsProminentsSection.classList.remove('d-none')
                        }
                    }
                })
            }
        }
    }, [city_id]);

    return (
        <RealtorsSlider realtors={realtors} className={className}/>
    )
}

export default RealtorsProminentsSlider;